import React from 'react';
import { QueryKeys } from '../../../../queryKeys';
import { mapDOCUMENT_ACTIONS_ERROR, mapERRORS } from '../../../../constraints';

// Hooks
import { useQueryClient } from 'react-query';
import { useDeleteDocument } from '../../hooks';

// Components
import { FormattedMessage } from 'react-intl';
import { ExportableErrorContent } from '../../../../components/ExportableErrorContent';
import { ErrorModal } from '../../../../components/ErrorModal';
import { Modal as ModalModule } from 'billon-ui';

const { SuccessModal, ConfirmModal } = ModalModule;

export const DeleteDocumentModal = ({ isOpen, toggle, document }) => {
  const queryClient = useQueryClient();

  const {
    mutate: deleteDocument,
    isLoading: isDeletingDocument,
    isSuccess,
    error,
    isError,
    reset,
  } = useDeleteDocument({
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.DOCUMENT_LIST]);
    },
  });

  const onAcceptDeleteDocument = () => deleteDocument({ id: document?.jobId });

  const onCloseSuccessErrorModal = () => {
    toggle();
    reset();
  };

  if (!isOpen || !document) return null;

  if (isError) {
    const errorStatusCode = error?.response?.data?.statusCode;
    const chosenStatusCode = mapERRORS[errorStatusCode] && errorStatusCode;

    return (
      <ErrorModal
        isOpen
        toggle={onCloseSuccessErrorModal}
        onClose={onCloseSuccessErrorModal}
        closeIconEnabled={false}
      >
        <ExportableErrorContent
          headerTitleId={mapDOCUMENT_ACTIONS_ERROR.DELETE}
          statusCode={chosenStatusCode}
          jobId={document?.jobId}
          title={document.title}
        />
      </ErrorModal>
    );
  }

  if (isSuccess) {
    return (
      <SuccessModal
        isOpen
        title={
          <FormattedMessage
            id="Document deleted"
            defaultMessage="Document deleted"
          />
        }
        onClose={onCloseSuccessErrorModal}
      >
        <FormattedMessage
          id="Document has been deleted successfully."
          defaultMessage="Document has been deleted successfully."
        />
      </SuccessModal>
    );
  }

  return (
    <ConfirmModal
      isLoading={isDeletingDocument}
      isOpen
      title={
        <FormattedMessage
          id="Document deletion confirmation"
          defaultMessage="Document deletion confirmation"
        />
      }
      onAccept={onAcceptDeleteDocument}
      onCancel={toggle}
    >
      <FormattedMessage
        id="Are You sure You want to delete this document?"
        defaultMessage="Are You sure You want to delete this document?"
      />
    </ConfirmModal>
  );
};
